'use strict';
var $ = require('jquery');
var Backbone = require('backbone');
var _ = require('underscore');
var Common = require('../common');

module.exports = Backbone.View.extend({

    initialize: function () {
        console.log('Initializing DeliveryView');

        //Set menu
        Common.MainMenuEntries.setSelected('delivery');
    },


    /////////////////////////////////////
    // Render
    /////////////////////////////////////
    template: _.template($('#delivery-template').html(), { interpolate: /\{\{(.+?)\}\}/g }),
    render: function () {
        $(this.el).html(this.template());

        $(function () {
            $('#pageTitle').html('Track delivery');
        });
        return this;
    },

    /////////////////////////////////////
    // Destroy
    /////////////////////////////////////
    destroy: function () {
        this.remove();
        return Backbone.View.prototype.remove.apply(this, arguments);
    }
});